<div class="wrapper" *ngIf="menu">
  <div>
    {{menu.label}}
  </div>

  <div class="overlay" *ngIf="mouseActive">
    <fa-icon [icon]="faArrowLeft" (click)="onMove(-1)"></fa-icon>
    <fa-icon [icon]="faArrowRight" (click)="onMove(+1)"></fa-icon>
    <fa-icon [icon]="faPlus" (click)="onAdd()"></fa-icon>
    <fa-icon [icon]="faTrash" (click)="onDelete()"></fa-icon>
    <fa-icon [icon]="faEdit" (click)="onEditMenu(content)"></fa-icon>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Menu</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="menuForm" (ngSubmit)="modal.close('Save click')">
      <div class="form-group">
        <label for="label">Label</label>
        <input id="label" class="form-control" [formControlName]="'label'">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel click')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSave(modal)">Save</button>
  </div>
</ng-template>
